/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const SEARCH_PEOPLE = "SEARCH_PEOPLE";
export const SEARCH_PEOPLE_SUCCESS = "SEARCH_PEOPLE_SUCCESS";
export const SEARCH_PEOPLE_FAILURE = "SEARCH_PEOPLE_FAILURE";
